import apiClient from '../client'
import type { User } from '@/stores/auth'

export interface LoginRequest {
  email: string
  password: string
}

export interface LoginResponse {
  access_token: string
  refresh_token: string
  token_type: string
  user: User
}

export interface PasswordResetRequest {
  email: string
}

export const authApi = {
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>('/api/v1/auth/login', data)
    return response.data
  },
  
  refreshToken: async (refreshToken: string): Promise<{ access_token: string; token_type: string }> => {
    const response = await apiClient.post('/api/v1/auth/refresh', {
      refresh_token: refreshToken,
    })
    return response.data
  },
  
  getMe: async (): Promise<User> => {
    const response = await apiClient.get<User>('/api/v1/auth/me')
    return response.data
  },
  acceptTos: async (): Promise<{ success: boolean; accepted_at: string }> => {
    const response = await apiClient.post('/api/v1/auth/accept-tos')
    return response.data
  },
  
  resetPassword: async (data: PasswordResetRequest): Promise<{ message: string }> => {
    const response = await apiClient.post('/api/v1/auth/reset-password', data)
    return response.data
  },

  confirmPasswordReset: async (data: { token: string; new_password: string }): Promise<{ message: string }> => {
    const response = await apiClient.post('/api/v1/auth/reset-password/confirm', data)
    return response.data
  },
}
